<template>
  <div class="wrapper">
    <Loader v-if="loading"></Loader>
    <transition name="balloon">
      <article
        v-if="!loading"
        class="balloon"
      >
        <h3 class="name">
          <slot name="name"></slot>
        </h3>
        <div class="messsage">
          <slot name="message"></slot>
        </div>
        <p class="date">
          {{ posted }}
        </p>
        <svg
          width="24"
          height="20"
          xmlns="http://www.w3.org/2000/svg"
          class="curve"
        >
          <path
            d="M20.63 4.823c2.473-3.467 2.315-5.935 2.473-4.314C25.052 20.598 17.309 23.556 0 16.61c10.766 0 14.264-2.859 20.63-11.786z"
            fill="#FFF"
            fill-rule="evenodd"
          />
        </svg>
      </article>
    </transition>
  </div>
</template>

<script>
import Loader from '@/components/Loader'

export default {
  name: 'Balloon',
  data () {
    return {
      posted: 'Zojuist',
      count: 0,
      loading: true
    }
  },
  components: {
    Loader
  },
  methods: {
    isLoaded () {
      setTimeout(() => {
        this.loading = false
      }, 1500)
    }
  },
  mounted () {
    this.isLoaded()

    const secondsInMinute = 60 * 1000
    setInterval(() => {
      this.count++
      const ext = this.count === 1 ? 'minuut geleden' : 'minuten geleden'
      this.posted = `${this.count} ${ext}`
    }, secondsInMinute)
  }
}
</script>

<style lang="scss" scoped>
.balloon {
  background-color: white;
  font-size: 16px;
  line-height: 1.19;
  border-radius: 10px;
  padding: 14px 18px 14px 18px;
  text-align: left;
  margin-bottom: 19px;
  position: relative;
  color: #313345;
  max-width: 325px;
  transition: all 400ms ease;
}
.name {
  font-weight: $fw-bold;
  margin-bottom: 2px;
}
.message {
}
.date {
  color: #5667C6;
  font-size: 12px;
  text-align: right;
}
.curve {
  position: absolute;
  left: -17px;
  bottom: 11px;
}
.balloon-enter, .balloon-leave-active {
  opacity: 0;
  transform: translateY(5px) scale(0.6);
}
</style>



// WEBPACK FOOTER //
// src/components/chat/Balloon.vue